export const GridListCard = {
  baseStyle: {
    bg: "#ffffff",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.07)",
    borderRadius: "15px",
  },
}
